import React, { FC } from 'react';
import placeholder from 'assets/images/placeholder.png';

interface IComponentProps {
  url?: string | null;
  className: string;
}

export const Avatar: FC<IComponentProps> = ({ url, className }) => {
  return <img className={className} src={url || placeholder} alt="Avatar" />;
};
